import * as React from "react";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import Button from "@mui/material/Button";

import { useUser } from "../../globals/UserContext.js";
import { useAssignment } from "../../globals/AssignmentContext.js";
import { useQuestion, useSetQuestion } from "../../globals/QuestionContext";
import { Grid } from "@mui/material";
import { useSetHtml } from "../../globals/HtmlContext.js";
import { fetchQuestionAction } from "../../actions/fetchQuestion.js";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function QuestionNav() {
  // const { assignments } = useUser();
  const assignment = useAssignment();
  const question = useQuestion();
  const user = useUser();
  const setQuestion = useSetQuestion();
  const setHtml = useSetHtml();

  const [anchorEl, setAnchorEl] = React.useState(null);
  // const [selectedIndex, setSelectedIndex] = React.useState(1);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuItemClick = (event, index) => {
    let questionInstance = assignment.questions[index];
    let questionID =
      typeof questionInstance === "string"
        ? questionInstance
        : questionInstance._id;
    fetchQuestionAction(questionID, assignment._id, setQuestion, setHtml, user);
    handleClose();
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  React.useEffect(() => {
    let questionInstance = assignment?.questions[0];
    let questionID =
      typeof questionInstance === "string"
        ? questionInstance
        : questionInstance?._id;
    if (questionID) {
      fetchQuestionAction(
        questionID,
        assignment?._id,
        setQuestion,
        setHtml,
        user
      );
    }

    //setQuestion(assignment.questions[0]);
  }, [assignment]);

  return (
    <Grid item>
      <Button
        variant="contained"
        color="gray"
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        {`Question ${assignment?.questions?.indexOf(question?._id) + 1}`}{" "}
        <ExpandMoreIcon />
      </Button>
      <Menu
        id="lock-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "lock-button",
          role: "listbox",
        }}
      >
        {assignment?.questions?.map((questionOption, index) => (
          <MenuItem
            key={questionOption}
            selected={questionOption === assignment}
            onClick={(event) => handleMenuItemClick(event, index)}
          >
            {`Question ${index + 1}`}
          </MenuItem>
        ))}
      </Menu>
    </Grid>
  );
}
